import formatDistanceToNow from 'date-fns/formatDistanceToNow'

export function formatLeadIntent(intent) {
  return (intent ?? '').replace(/\s,/g, '').replace(/^,\s/g, '')
}

export function formatLeadHeaderMeta({ createdAt, intent }) {
  const parts = []

  if (createdAt) {
    parts.push(
      `Submitted ${formatDistanceToNow(Date.parse(createdAt), {
        addSuffix: false,
      })} ago`,
    )
  }

  const cleanedIntent = formatLeadIntent(intent)
  if (cleanedIntent) {
    parts.push(cleanedIntent)
  }

  return parts.length ? parts.join(' · ') : null
}
